<div class="merchant-enquiry-page">


<div class="page-title">

<div class="icon">

<span class="material-symbols-outlined">
forum
</span>

</div>


<div>

<h1>
Customer Enquiries
</h1>

<p>
Manage customer conversations
</p>

</div>


</div>




<div class="enquiry-layout">



<!-- LEFT LIST -->

<div class="enquiry-list">


<!-- SEARCH -->

<div class="search-box">

<span class="material-symbols-outlined">
search
</span>

<input
type="text"
placeholder="Search enquiries"
/>

</div>




<div
class="enquiry-item"

*ngFor="let enquiry of enquiries"

(click)="selectEnquiry(enquiry)"

[class.active]="selectedEnquiry?._id===enquiry._id"
>



<div class="avatar">

<span class="material-symbols-outlined">
person
</span>

</div>




<div class="item-content">


<div class="item-top">


<h3 class="service-title">
{{enquiry.user_name}}
</h3>


<span class="time">

{{enquiry.messages[enquiry.messages.length-1]?.created_at 
| date:'hh:mm a'}}

</span>


</div>



<div class="service-name">
{{enquiry.service_name}}
</div>

<p>
{{enquiry.messages[enquiry.messages.length-1]?.message}}
</p>



<div class="item-bottom">


<!-- <span class="status">

{{enquiry.status}}

</span> -->



<span
class="count unread"
*ngIf="enquiry.merchant_unread_count>0">

{{enquiry.merchant_unread_count}}

</span>


</div>



</div>



</div>



</div>






<!-- CHAT -->

<div class="chat-box"
*ngIf="selectedEnquiry">



<div class="chat-header">
<button class="mobile-back-btn" (click)="selectedEnquiry = null">
  <span class="material-symbols-outlined">
    arrow_back
  </span>
</button>

<div class="avatar large">

<span class="material-symbols-outlined">
person
</span>

</div>



<div class="header-details">

<h2>
{{selectedEnquiry.user_name}}
</h2>

<p>
{{selectedEnquiry.service_name}}
</p>

</div>
<!-- SERVICE DETAILS BUTTON -->

<button
class="service-details-btn"
(click)="openServiceDetails()"
*ngIf="selectedEnquiry.service_details">


<span class="material-symbols-outlined">
info
</span>

Service Details


</button>



<button
(click)="closeTicket()">


<span class="material-symbols-outlined">
delete
</span>


Close


</button>



</div>





<div class="messages" #chatContainer>


<div
class="message"
*ngFor="let msg of selectedEnquiry.messages"

[class.user]="msg.sender_type==='USER'"

[class.merchant]="msg.sender_type==='MERCHANT'"
>


<div class="bubble">


<div class="sender">

{{msg.sender_name}}

</div>


<p>
{{msg.message}}
</p>



<div class="message-info">


<span>

{{msg.created_at | date:'hh:mm a'}}

</span>



<span
*ngIf="msg.sender_type==='MERCHANT'"
[class.read]="msg.status==='READ'"
[class.delivered]="msg.status==='DELIVERED'">

{{msg.status==='SENT' ? '✓' : '✓✓'}}

</span>


</div>


</div>


</div>


</div>






<div class="reply-box">


<textarea

[(ngModel)]="replyMessage"

placeholder="Type your reply">

</textarea>



<button
(click)="sendReply()">

<span class="material-symbols-outlined">
send
</span>

Send

</button>


</div>




</div>




</div>
<!-- SERVICE DETAILS POPUP -->


<div class="overlay"
*ngIf="showServiceDetails">


<div class="service-modal">


<div class="modal-header">

<h2>
Service Details
</h2>


<button
(click)="closeServiceDetails()">

✕

</button>


</div>



<div
*ngIf="selectedEnquiry?.service_details"
class="service-content">


<h3>
{{selectedEnquiry.service_details.service_name}}
</h3>



<p>
{{selectedEnquiry.service_details.description}}
</p>



<div class="detail-row">


<span>
💰 Price
</span>


<strong>
₹{{selectedEnquiry.service_details.price}}
</strong>


</div>




<div class="detail-row">


<span>
⏱ Duration
</span>


<strong>
{{selectedEnquiry.service_details.duration}}
</strong>


</div>




<div class="detail-row">


<span>
📍 Locations
</span>


<strong>
{{selectedEnquiry.service_details.service_locations.join(', ')}}
</strong>


</div>





<div class="included">


<h4>
Included
</h4>


<div
*ngFor="let item of selectedEnquiry.service_details.included">

✓ {{item}}

</div>


</div>



</div>



</div>


</div>

</div>